export default "__VITE_ASSET__7ae197ca__"